module.exports = __webpack_public_path__ + "img/juxue1.0d533dc9.png";